import camelCase from 'lodash/camelCase';

/**
 * Adds mutations for handling adding new doc.
 *
 * @param {Function} addApi - a functions that can adds the required data to
 * backend. This is an optional field only if passed the corresponding action
 * will be created.
 *
 * NOTE: Please make sure `canUpdate` plugin is also included if
 * you are using addApi.
 *
 * @returns {Function} that will take a module and apply the plugin.
 */
export default function(addApi) {
  return function(module) {
    const uName = module.name.toUpperCase();
    const CREATED = `${uName}_CREATED`;
    module.addMutationTypes([CREATED]);

    const newIdKey = camelCase(`new_${module.name}_id`);

    const state = {
      [newIdKey]: null
    };

    const mutations = {
      [CREATED](state, id) {
        state[newIdKey] = id;
      }
    };

    const actions = {
      ...(addApi
        ? {
            async [camelCase(`add_${module.name}`)]({ commit }, data) {
              commit(module.con[`${uName}_SUBMIT_INIT`]);
              try {
                const ref = await addApi(data);
                commit(module.con[`${uName}_CREATED`], ref.id);
                commit(module.con[`${uName}_SUBMIT_DONE`]);
              } catch (error) {
                commit(module.con[`${uName}_SUBMIT_DONE`]);
                throw error;
              }
            }
          }
        : {})
    };

    return module.extend({ state, mutations, actions });
  };
}
